<template>
    <div>
        <az-sub-title title="Sinalizadores">
            <a class="card-link" href="#" @click.prevent="incluir()" v-if="!viewonly">
                <i class="fas fa-plus mr-2"></i>
                Incluir
            </a>
        </az-sub-title>
        <div v-if="model.sinalizadores && model.sinalizadores.length">
            <div v-for="(sinalizador, isx) in model.sinalizadores" :key="isx">
                <div class="form-row" v-show="sinalizador.fl_ativo">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            v-if="sinalizador.id_sinalizador_aplicado"
                            sizing="sm"
                            v-model="sinalizador.sinalizador.search" 
                            :edicao="false">  
                            <template v-slot:button-pre>
                                <div class="input-group-prepend" v-if="!viewonly">
                                    <button class="btn btn-sm btn-outline-danger" type="button" @click="sinalizador.fl_ativo = false">
                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input 
                            v-else
                            sizing="sm"
                            type="select"
                            service="gen_sinalizadores.index"
                            optionsMode="aql"
                            :optionsName="'gen_sinalizadores.index.' + model_type"
                            :optionsParm="{ ativos: 1, model_type: model_type }"
                            optionsData="id_sinalizador"
                            v-model="sinalizador.id_sinalizador">  
                            <template v-slot:button-pre>
                                <div class="input-group-prepend" v-if="!viewonly">
                                    <button class="btn btn-sm btn-outline-danger" type="button" @click="sinalizador.fl_ativo = false">
                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input 
                            sizing="sm"
                            placeholder="Observação..."
                            v-model="sinalizador.st_observacao" />
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            Nenhum sinalizador registrado.
        </div>
    </div>
</template>

<script>
import AzSubTitle from '../util/AzSubTitle.vue';
import AzInput from './forms/AzInput.vue';

export default {
    components: { 
        AzSubTitle, 
        AzInput 
    },
    
    props: [
        'model', 
        'viewonly', 
        'model_type',
        'model_id'
    ],

    methods: { 
        incluir() { 
            console.log('inc', this.model);

            this.model.sinalizadores.push ({ 
                id_sinalizador_aplicado: null, 
                id_sinalizador: "",
                model_type: this.model_type,
                model_id: this.model_id,  
                fl_ativo: true, 
                st_observacao: "", 
            });
        }
    }
}
</script>
